// src/utils/logger.js

const isDevelopment = process.env.NODE_ENV === 'development';

/**
 * A simple logger that only outputs messages in the development environment.
 * This helps keep the console clean in production.
 */
const logger = {
  log: (...args) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },
  error: (...args) => {
    if (isDevelopment) {
      console.error(...args);
    }
  },
  warn: (...args) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },
};

export default logger;